import { api } from "../fetchWrapper";
import { API_ENDPOINTS, getEndpoint } from "../apiConstants";
import type { AuthResponse, UserResponse, PermissionResponse } from "./auth";

// Login function - uses direct fetch for OAuth token
export async function login({
  username,
  password,
  clientCode = "admin"
}: {
  username: string;
  password: string;
  clientCode?: string;
}): Promise<AuthResponse> {
  const params = new URLSearchParams({
    username,
    password,
    clientCode,
    grant_type: "password",
    scope: "read,write,trust",
  });

  // Basic Auth header value
  const basicAuth = "Basic Y3JtQ2xpZW50MTpjcm1TdXBlclNlY3JldA==";

  const response = await fetch(`/api/projectag/${API_ENDPOINTS.AUTH.LOGIN}?${params.toString()}`, {
    method: 'POST',
    headers: {
      "Authorization": basicAuth,
      "Content-Type": "application/x-www-form-urlencoded",
      "charset": "utf-8",
    },
  });

  if (!response.ok) {
    throw new Error('Login failed');
  }

  const data = await response.json();
  
  // Store only essential tokens (matching production)
  localStorage.setItem("access_token", data.access_token);
  localStorage.setItem("refresh_token", data.refresh_token);
  
  return data;
}

export async function getUser(username: string, clientCode: string, accessToken: string): Promise<UserResponse> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.AUTH.GET_USER);
  return api.post(endpoint, { username });
}

export async function getPermissions(username: string, clientCode: string, accessToken: string): Promise<PermissionResponse[]> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.AUTH.GET_PERMISSIONS);
  return api.post(endpoint, { username });
} 